import React from 'react'
import { Icon } from '@adc/ui-morpheus'

type ChatNotebookIconProps = {
  style?: React.CSSProperties
  className?: string
}

const ChatNotebookIcon: React.FC<ChatNotebookIconProps> = ({
  style,
  className,
}) => {
  return (
    <div style={{ position: 'relative', ...style }}>
      <Icon
        className={className}
        name='notebook'
        size='huge'
        color='adc-light-blue'
        iconStyle='solid'
        elmId='chat_notebook_icon'
      />
      <Icon
        className={className}
        style={{ position: 'absolute', top: '31%', left: '43%', ...style }}
        name='sparkles'
        size='large'
        color='white'
        iconStyle='solid'
        elmId='sparkles_icon'
      />
    </div>
  )
}

export default ChatNotebookIcon
